import { useEffect } from 'react';
import { Chip, InputAdornment, OutlinedInput, Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Search as SearchIcon } from '@mui/icons-material';

import PageContainer from 'components/v2/container/PageContainer';
import DashboardTasks from './tasks/DashboardTasks';
import DashboardLatestCases from './cases/DashboardLatestCases';
import { colors } from 'theme/mui/colors';
import { MODAL_ID, MODALS_STORE } from 'constants/ui/modal';
import { useLocalization } from 'localization';
import DashboardAdsAccount from './advertising/DashboardAdsAccount';
import Banner from 'components/v2/shared/Banner';
const DashBoard = () => {
  const { toggleModal } = MODALS_STORE.general();
  const { t } = useLocalization();

  // listen for Cmd+K / Ctrl+K
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      // Mac: metaKey (⌘), Windows/Linux: ctrlKey
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault(); // stop browser search or other handlers
        toggleModal(MODAL_ID.GLOBAL_SEARCH);
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [toggleModal]);

  return (
    <PageContainer pageTitle="navigation.mainMenu.dashboard">
      <Stack
        sx={{
          p: {
            sm: 0,
          },
        }}
        spacing={'1.5rem'}
      >
        <Banner />

        <OutlinedInput
          type="text"
          readOnly
          onClick={() => toggleModal(MODAL_ID.GLOBAL_SEARCH)}
          placeholder={t('dashboard.cases.searchGlobalPlaceholder')}
          startAdornment={<SearchIcon color="action" sx={{ color: colors.primary.main, marginRight: '0.5rem' }} />}
          endAdornment={
            <InputAdornment position="end">
              <Chip
                label=" Cmd+K / Ctrl+K"
                sx={{ borderRadius: '0.5rem', color: colors.base.level60, background: colors.base.level30 }}
              />
            </InputAdornment>
          }
          sx={{ width: '100%', border: 'none', boxShadow: ` 0px 1px 3px 0px rgba(18, 18, 23, 0.10)` }}
        />
        <Grid
          container
          spacing="1.25rem"
          sx={{
            '& .MuiGrid2-root': {
              display: 'flex',
              '& > *': {
                width: '100%',
              },
            },
          }}
        >
          <Grid size={{ xs: 12, md: 6 }}>
            <DashboardAdsAccount />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <DashboardTasks />
          </Grid>
          {/* <Grid size={{ xs: 12, md: 6, lg: 4 }}>
            <DashboardAdvertising />
          </Grid> */}
        </Grid>
      </Stack>
      <DashboardLatestCases />
    </PageContainer>
  );
};

export default DashBoard;
